module.exports = __webpack_public_path__ + "img/totalNilaiAsset.b7fed04d.png";